export default __webpack_public_path__ + "static/media/pkLogoForWhiteBk.b5d28a7f.svg";